module.exports = __webpack_public_path__ + "static/img/t17.c968692d.png";